import React from 'react'
import StructuredDataMap from './StructuredDataMap'
import { entryPointId, PAGE_TYPES } from 'settings/app/constants'
import { translateDaysOfWeek } from 'settings/app/helpers'
import { array, arrayOf, oneOf, oneOfType, shape, string } from 'prop-types'

const StructuredData = ({ pageType, entryPoint, searchResults }) => {
  const getDefaultImage = () => {
    const basePath = 'https://www.aok.de/'
    if (pageType === PAGE_TYPES.SEO_PAGE) {
      return basePath + localStorage.getItem('headerImage')
    }
    // TODO: add Detail default image when Detail SEO is implemented
    /* if (pageType === entryPointId.DOCTORS) {
        }*/
    // TODO: add Detail default image when Detail SEO is implemented
    /* if (pageType === entryPointId.HOSPITALS) {
        }*/
    return basePath + localStorage.getItem('headerImage')
  }
  const mapOpeningHours = (openingHours) => {
    let mappedOpeningHours = []
    Object.keys(openingHours).forEach((day) => {
      mappedOpeningHours = [
        ...mappedOpeningHours,
        ...openingHours[day].flatMap((time) =>
          time.includes('geschlossen')
            ? []
            : [
                {
                  '@type': 'OpeningHoursSpecification',
                  opens: time.split(' - ')[0],
                  closes: time.split(' - ')[1],
                  dayOfWeek: `https://schema.org/${ translateDaysOfWeek(day) }`,
                },
              ]
        ),
      ]
    })
    return mappedOpeningHours
  }

  const getStructuredData = () => {
    if (pageType === entryPointId.DOCTORS) {
      return {
        '@context': 'https://schema.org',
        '@type':
          searchResults.specification.includes('Zahn') ||
          searchResults.specification.includes('Kiefer')
            ? StructuredDataMap.DOCTORS.DENTIST
            : StructuredDataMap.DOCTORS.DEFAULT,
        name: searchResults.name,
        address: {
          '@type': 'PostalAddress',
          addressCountry: 'DE',
          addressLocality: searchResults.address.city,
          postalCode: searchResults.address.zip,
          streetAddress:
            searchResults.address.street +
            (searchResults.address.streetAddition &&
              ` ${ searchResults.address.streetAddition }`),
        },
        telephone: searchResults.phone,
        url: searchResults.website,
        image: searchResults?.slideshowOffice ?? getDefaultImage(),
        ...(searchResults.details.businessHours.openingHours &&
          Object.keys(searchResults.details.businessHours.openingHours).length >
            0 && {
            openingHoursSpecification: mapOpeningHours(
              searchResults.details.businessHours.openingHours.hours
            ),
          }),
      }
    }
    if (
      pageType === PAGE_TYPES.SEO_PAGE &&
      entryPoint === entryPointId.DOCTORS
    ) {
      return {
        '@context': 'https://schema.org',
        '@graph': searchResults.map((searchResult) => ({
          '@type':
            searchResult.subjectArea.includes('Zahn') ||
            searchResult.subjectArea.includes('Kiefer')
              ? StructuredDataMap.DOCTORS.DENTIST
              : StructuredDataMap.DOCTORS.DEFAULT,
          name: searchResult.name ?? searchResult.locationName,
          address: {
            '@type': 'PostalAddress',
            addressCountry: 'DE',
            addressLocality: searchResult.address.city,
            postalCode: searchResult.address.zip,
            streetAddress:
              searchResult.address.street +
              (searchResult.address.streetAddition &&
                ` ${ searchResult.address.streetAddition }`),
          },
          telephone: searchResult.phone,
          url: searchResult.website,
          image: searchResult?.slideshowOffice ?? getDefaultImage(),
          ...(searchResult.openingHours &&
            Object.keys(searchResult.openingHours).length > 0 && {
              openingHoursSpecification: mapOpeningHours(
                searchResult.openingHours
              ),
            }),
        })),
      }
    }
    // TODO: will be used when Detail SEO is implemented
    /* if (pageType === entryPointId.HOSPITALS) {
            return {
                '@context': 'https://schema.org',
                '@type': StructuredDataMap.HOSPITALS,
            }
        }*/
    // TODO: will be used when hospital SEO is implemented
    /* if ( pageType === PAGE_TYPES.SEO_PAGE &&
            entryPoint === entryPointId.HOSPITALS) {
            return {
                '@context': 'https://schema.org',
                '@graph': searchResults.map(searchResult => ({
                    '@type': StructuredDataMap.HOSPITALS,
                    'name': searchResult.locationName,
                    'address': {
                        '@type': 'PostalAddress',
                        'addressCountry': 'DE',
                        'addressLocality': searchResult.address.city,
                        'postalCode': searchResult.address.zip,
                        'streetAddress': searchResult.address.street + (searchResult.address.streetAddition && ` ${ searchResult.address.streetAddition }`),
                    },
                    'url': searchResult.website,
                    'image': '',
                })),
            }
        }*/
    // TODO: will be used when Detail SEO is implemented
    /* return {
            '@context': 'https://schema.org',
            '@type': StructuredDataMap.DEFAULT,
        }
        */
  }

  return (
    <>
      {Object.keys(searchResults).length > 0 && (
        <script type={ 'application/ld+json' }>
          {JSON.stringify(getStructuredData())}
        </script>
      )}
    </>
  )
}

StructuredData.propTypes = {
  pageType: oneOf([
    PAGE_TYPES.SEO_PAGE,
    entryPointId.DOCTORS,
    entryPointId.HOSPITALS,
  ]).isRequired,
  entryPoint: oneOf([entryPointId.DOCTORS, entryPointId.HOSPITALS]).isRequired,
  searchResults: oneOfType([
    shape({
      name: string.isRequired,
      address: shape({
        city: string.isRequired,
        zip: string.isRequired,
        street: string.isRequired,
        streetAddition: string,
      }).isRequired,
      details: shape({
        businessHours: shape({
          openingHours: shape({
            Montag: arrayOf(string),
            Dienstag: arrayOf(string),
            Mittwoch: arrayOf(string),
            Donnerstag: arrayOf(string),
            Freitag: arrayOf(string),
            Samstag: arrayOf(string),
            Sonntag: arrayOf(string),
            Feiertag: arrayOf(string),
          }),
        }),
      }).isRequired,
      website: string,
      image: oneOf([array, string]),
    }),
    arrayOf(
      shape({
        name: string,
        locationName: string.isRequired,
        address: shape({
          city: string.isRequired,
          zip: string.isRequired,
          street: string.isRequired,
          streetAddition: string,
        }).isRequired,
        website: string,
        image: oneOf([array, string]),
      })
    ),
  ]).isRequired,
}

export default StructuredData
